//REGISTER
export const USER_REGISTER = "/users/register/";

//LOGIN
export const USER_LOGIN = "/users/login/";

export const USER_DETAILS = "/users/user-profile/";

export const REFRESH_TOKEN = "/users/refresh-token/";

//LOGIN
export const SAVE_NOTIFICATION_TOKEN = "/users/save-fcm-token/";

//FORGOT PASSWORD
export const FORGOT_PASSWORD = "users/v1/send-otp/";

// VERIFY CODE
export const VERIFY_CODE = "users/v1/otp-verify/";

// RESET PASSWORD
export const RESET_PASSWORD = "users/v1/reset-password/";

// UPDATE PROFILE PIC
export const UPDATE_PROFILE_PIC = "/users/update-profile-picture/";

// UPDATE PROFILE DETAILS
export const UPDATE_PROFILE_DETAILS = "/users/update/";

// CHANGE PASSWORD
export const CHANGE_PASSWORD = "/users/change-password/";

// ----------------------------------------------------------------------------------------------------

// TRIP LIST

export const GET_TRIPS = "/vehicle-trip/tripdetails/";

export const GET_TRIPS_BY_ID = "/vehicle-trip/tripdetails";

export const CREATE_TRIPS = "/vehicle-trip/tripdetails-create/";

export const CREATE_TRIPS_USING_EXCEL = "/vehicle-trip/upload-trip-sheet/"

export const UPDATE_TRIPS = "/vehicle-trip/tripdetails";

export const ASSIGN_TRIPS = "/vehicle-trip/tripdetails";

export const UPLOAD_TRIPS = "/vehicle-trip/upload-file/";

export const DELETE_TRIP = "/vehicle-trip/tripdetails";

// ----------------------------------------------------------------------------------------------------

// VEHICLE LIST

export const VEHICLE_LIST = "/vehicle/vehicles/";

export const VEHICLE_BY_ID = "/vehicle/vehicles";

export const VEHICLE_TYPE = "/vehicle/vehicle-types/";

export const VEHICLE_CREATE_API = "/vehicle/vehicles/";

export const VEHICLE_UPDATE_API = "/vehicle/vehicles";

export const VEHICLE_DELETE_API = "/vehicle/vehicles";

// ----------------------------------------------------------------------------------------------------

// MAINTENANCE

export const GET_MAINTENANCE =
  "/vehicle-maintenance-insurance/maintenance/";

export const CREATE_MAINTENANCE =
  "/vehicle-maintenance-insurance/maintenance/";

export const MAINTENANCE_BY_ID =
  "/vehicle-maintenance-insurance/maintenance";

export const UPDATE_MAINTENANCE =
  "/vehicle-maintenance-insurance/maintenance";

export const DELETE_MAINTENANCE =
  "/vehicle-maintenance-insurance/maintenance";

export const DELETE_IMAGE = "/vehicle-maintenance-insurance/maintenance-file-delete";

// ----------------------------------------------------------------------------------------------------

// INSURANCE

export const GET_INSURANCE =
  "/vehicle-maintenance-insurance/insurance/";

export const CREATE_INSURANCE =
  "/vehicle-maintenance-insurance/insurance/";

export const INSURANCE_BY_ID =
  "/vehicle-maintenance-insurance/insurance";

export const UPDATE_INSURANCE =
  "/vehicle-maintenance-insurance/insurance";

export const DELETE_INSURANCE =
  "/vehicle-maintenance-insurance/insurance";

export const DELETE_INSURANCE_IMAGE =
  "/vehicle-maintenance-insurance/insurance-file-delete";


// ----------------------------------------------------------------------------------------------------

// ROLES AND PERMISSION

export const GET_ROLES = "/role-and-permission/roles/";

export const CREATE_ROLES = "/role-and-permission/roles/";

export const ROLE_BY_ID = "/role-and-permission/roles";

export const UPDATE_ROLE = "/role-and-permission/roles";

export const DELETE_ROLE = "/role-and-permission/roles";

export const GET_PERMISSIONS = "/role-and-permission/permissions/";

// ----------------------------------------------------------------------------------------------------

// SALARY MANAGEMENT

export const GET_SALARY = "/salary-management/driver-salary-management";

export const CREATE_SALARY = "/salary-management/driver-salary-management/";

export const SALARY_BY_ID = "/salary-management/driver-salary-management";

export const UPDATE_SALARY = "/salary-management/driver-salary-management";

export const DELETE_SALARY = "/salary-management/driver-salary-management";

// ----------------------------------------------------------------------------------------------------

// USER MANAGEMENT

export const GET_USERS = "/users/users/";

export const CREATE_USER = "/users/users/";

export const USER_BY_ID = "/users/users";

export const UPDATE_USER = "/users/users";

export const DELETE_USER = "/users/users";


// ----------------------------------------------------------------------------------------------------

// ADMIN DASHBOARD 

export const GET_ADMIN_DASHBOARD_DETAILS = "/admin-dashboard/admin_dashboard/";


// ----------------------------------------------------------------------------------------------------

// TRIP DASHBOARD 

export const GET_TRIP_DASHBOARD_DETAILS = "/dashboard/dashboard/"


// ----------------------------------------------------------------------------------------------------

export const GET_REVENUE_EXPENSES = "/admin-dashboard/revenue-and-expenses/"


// ----------------------------------------------------------------------------------------------------

export const GET_TRIP_LIST_DETAILS_REAL_TIME = "/real-time-trip/realtimetrip/"



// ----------------------------------------------------------------------------------------------------


export const CREATE_DRIVER = "/users/drivers/create/"

export const UPDATE_DRIVER = "/users/drivers/update"

export const DELETE_DRIVER = "/users/drivers/delete"

export const GET_LIST_DRIVER = "/users/drivers/"

export const GET_DRIVER_BY_ID = "/users/drivers/select"


// ----------------------------------------------------------------------------------------------------

export const GET_MAINTENANCE_CATEGORY = "/vehicle-maintenance-insurance/maintenance-types/"
export const CREATE_MAINTENANCE_CATEGORY = "/vehicle-maintenance-insurance/maintenance-types/"
export const UPDATE_MAINTENANCE_CATEGORY = "/vehicle-maintenance-insurance/maintenance-types"
export const DELETE_MAINTENANCE_CATEGORY = "/vehicle-maintenance-insurance/maintenance-types"
export const GET_MAINTENANCE_CATEGORY_BY_ID = "/vehicle-maintenance-insurance/maintenance-types"


// ----------------------------------------------------------------------------------------------------


export const GET_INSURANCE_CATEGORY = "/vehicle-maintenance-insurance/insurance-types/"
export const CREATE_INSURANCE_CATEGORY = "/vehicle-maintenance-insurance/insurance-types/"
export const UPDATE_INSURANCE_CATEGORY = "/vehicle-maintenance-insurance/insurance-types"
export const DELETE_INSURANCE_CATEGORY = "/vehicle-maintenance-insurance/insurance-types"
export const GET_INSURANCE_CATEGORY_BY_ID = "/vehicle-maintenance-insurance/insurance-types"


// ----------------------------------------------------------------------------------------------------


export const GET_VEHICLE_CATEGORY = "/vehicle/vehicle-types/"
export const CREATE_VEHICLE_CATEGORY = "/vehicle/vehicle-types/"
export const UPDATE_VEHICLE_CATEGORY = "/vehicle/vehicle-types"
export const DELETE_VEHICLE_CATEGORY = "/vehicle/vehicle-types"
export const GET_VEHICLE_CATEGORY_BY_ID = "/vehicle/vehicle-types"